<template>
  <div>
    <SearchField
      v-bind="searchFieldProps"
      @update:inputData="handleChange"
    />
    <v-scroll-y-transition>
      <div v-if="changeLocationFieldVisible">
        <v-switch
          v-model="overrideUserWorkplace"
          :label="label"
          color="primary"
          hide-details
        ></v-switch>
      </div>
    </v-scroll-y-transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SearchField from '../field-types/Search.vue';

export default {
  components: {
    SearchField,
  },
  data: () => ({
    changeLocationFieldVisible: false,
    overrideUserWorkplace: false,
    label: null,
  }),
  methods: {
    handleChange(evt) {
      // TODO check if new value
      if (evt.item != null) {
        const newLocationId = evt.item.id;
        const currentLocationId = this.expressionInterpreter.fields?.requestedBy?.item.location.id;

        this.changeLocationFieldVisible = newLocationId !== currentLocationId;
        if (this.changeLocationFieldVisible
          && this.expressionInterpreter.fields?.requestedBy
          && this.expressionInterpreter.fields?.requestedBy?.item.id !== this.user.id
        ) {
          this.label = this.$t('views.form.overrideOtherUserWorkplace');
        } else {
          this.label = this.$t('views.form.overrideUserWorkplace');
        }
      }
      this.$emit('update:inputData', evt);

      this.$root.$emit('Updatesearch', evt);
    },
  },
  computed: {
    searchFieldProps() {
      return this.$attrs;
    },
    expressionInterpreter() {
      return this.$parent.expressionInterpreter;
    },
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  created() {
    console.log('created', this);
  },
};
</script>
